import axios from '@/libs/api.request'
const set = {
  // 实时库存、销售查询时段设置
  setRealTime: (data) => {
    return axios.post({
      url: '/Set/realTime',
      data: data
    })
  },
  // 实时库存、销售查询时段设置详情
  getRealTime: () => {
    return axios.get({
      url: '/Set/realTime'
    })
  }
}
export default set



// WEBPACK FOOTER //
// ./src/api/api-set.js